import React, { useEffect, useState } from "react";
import { ReactComponent as TrashIcon } from "../../../../../assets/dashboard/link/trashIcon.svg";
import { ReactComponent as TrashIconDark } from "../../../../../assets/dashboard/link/trashIcon-dark.svg";
import { useStateContext } from "../../../../../contexts/ThemeContext";
import { ReactComponent as GalleryEdit } from "../../../../../assets/MainPage/addBlock/imageBlock/gallery-edit.svg";
import { ReactComponent as GalleryEditDark } from "../../../../../assets/MainPage/addBlock/imageBlock/gallery-edit-dark.svg";
import { ReactComponent as TextIcon } from "../../../../../assets/MainPage/addBlock/imageBlock/text.svg";
import { ReactComponent as LinkIcon } from "../../../../../assets/MainPage/addBlock/imageBlock/link.svg";
import { ReactComponent as LinkIconDark } from "../../../../../assets/MainPage/addBlock/imageBlock/link-dark.svg";
import { ReactComponent as ImagePlacholder } from "../../../../../assets/dashboard/avatar/gallery.svg";
import { ReactComponent as ImagePlacholderDark } from "../../../../../assets/dashboard/avatar/gallery-dark.svg";
import { ReactComponent as DownArrow } from "../../../../../assets/settingPage/arrow-down.svg";
import { FileUploader } from "react-drag-drop-files";
import { toast } from "react-hot-toast";
import { useForm } from "react-hook-form";

import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import ExtraSmallFilledButton from "../../../../../components/common/buttons/ExtraSmallFilledButton";
import useLocales from "../../../../../hooks/useLocales";
import { useSelector } from "react-redux";
import { I18nextProvider } from "react-i18next";
import i18nForComponent from "../../../../../locales/component/i18nForComponent";

// This Form component is responsible for add and edit Image Block

const fileTypes = ["png", "jpg", "jpeg", "gif", "ico"];

const ImageForm = ({
  formType,
  submitHandlerParent,
  isLoading,
  handleDelete,
  preHeaderData,
}) => {
  const { darkMode } = useSelector((state) => state.theme);

  const { allLangs, tComponent, handleLanguageChange } =
    useLocales();

  const [file, setFile] = useState(null);
  const [filePreview, setFilePreview] = useState(null);
  const { setActiveMainPageNav } = useStateContext();
  const baseUrl = process.env.REACT_APP_API_URL;

  const [selectReporterTypeDropDown, setSelectReporterTypeDropDown] =
    useState(false);
  const [selectedReporterType, setSelectedReporterType] = useState("English");
  const [selectedLang, setSelectedLang] = useState("en");

  const schema = yup.object().shape({
    altDescription: yup.string().nullable().notRequired(),
    description: yup.string().nullable().notRequired(),
    url: yup.string().nullable().notRequired(),
  });

  useEffect(() => {
    setActiveMainPageNav(true);

    return () => {
      setActiveMainPageNav(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (selectedLang) {
      handleLanguageChange(selectedLang);
    }
  }, [selectedLang]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
  } = useForm({ resolver: yupResolver(schema) });

  const handleChange = (file) => {
    setFile(file);
    setFilePreview(URL.createObjectURL(file));
  };

  const submitHandler = async (formData) => {
    if (file) {
      formData.image = file;
    }
    formData.language = selectedLang;
    submitHandlerParent(formData);
  };

  useEffect(() => {
    const headerValue = preHeaderData?.data?.coloum_value;
    if (preHeaderData) {
      setFilePreview(baseUrl + "/profile/" + JSON.parse(headerValue)?.name);
      setValue("description", JSON.parse(headerValue)?.description);
      setValue("url", JSON.parse(headerValue)?.url);
      setValue("altDescription", JSON.parse(headerValue)?.altDescription);
        setSelectedLang(preHeaderData?.data?.language);
        const matchedLang = allLangs?.find(
          (lang) => lang.value === preHeaderData?.data?.language
        );
        const shouldSetLang = matchedLang?.label;
        setSelectedReporterType(shouldSetLang);
        handleLanguageChange(preHeaderData?.data?.language);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preHeaderData]);

  const deleteHandler = async (data) => {
    if (formType === "add") {
      reset();
      setFile(null);
      setFilePreview(null);
      setFile(null);
    } else {
      handleDelete(data);
    }
  };

  const handleChangeLang = (newLang) => {
    handleLanguageChange(newLang);
  };

  return (
    <I18nextProvider i18n={i18nForComponent}>
    <>
      <div
        className="sm:mt-7 md:px-0 mt-10 mb-6 px-6"
        style={{
          direction: selectedLang === "ar" ? "rtl" : "ltr",
        }}
      >
        <div className="border rounded-lg bg-light_bg_v5 dark:bg-dark-secondary p-[25px] dark:border-color_dark">
          <div className="flex justify-between items-center mb-[20px] sm:mb-[25px]">
            <p className="text-small2_b sm:text-small1_bold text-heading_color dark:text-color_v1_dark uppercase">
              {formType === "edit" && tComponent(`image.${formType}`)}
              {formType === "add" && tComponent(`image.${formType}`)}
              &nbsp;
              {tComponent(`image.image`)}
            </p>
            {formType === "add" && (
              <div className="flex items-center justify-center">
                <div className="relative w-[115px] sm:w-[145px]">
                  <div
                    onClick={() => {
                      setSelectReporterTypeDropDown(
                        !selectReporterTypeDropDown
                      );
                    }}
                    className={`bg-light_bg_v4 capitalize p-[13px] text-small2 lg:text-body_copy2 rounded-md w-full flex justify-between items-center cursor-pointer`}
                  >
                    {selectedReporterType
                      ? selectedReporterType
                      : tComponent("image.select_lang")}
                    <DownArrow />
                  </div>
                  {selectReporterTypeDropDown && (
                    <div className="absolute top-14 mb-20 left-0 w-full z-50 p-[7px] px-[10px] md:p-[15px] bg-light_bg_v5  rounded-lg border flex flex-col max-h-40 overflow-y-auto">
                      {allLangs?.map((item, i) => {
                        return (
                          <div
                            key={i}
                            onClick={() => {
                              setSelectedLang(item.value); // Set selected language code
                              setSelectedReporterType(item?.label);
                              setSelectReporterTypeDropDown(false);
                              handleChangeLang(item?.value);
                            }}
                            className="px-[10px] md:px-[15px] py-[7px] md:py-[10px] capitalize text-small2 lg:text-body_copy2 text-heading_color cursor-pointer hover:bg-light_bg_v4 rounded-md"
                          >
                            {item.label}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            )}
            {formType === "edit" && (
              <div
                className={`w-[100px] bg-light_bg_v4 capitalize p-[10px] text-small2 lg:text-body_copy2 rounded-md flex justify-center items-center`}
              >
                {selectedReporterType ? selectedReporterType : "English"}
              </div>
            )}
          </div>
          <form onSubmit={handleSubmit(submitHandler)}>
            {!filePreview && (
              <FileUploader
                handleChange={handleChange}
                name="file"
                types={fileTypes}
                maxSize={2}
                onSizeError={(errorMessage) => toast.error(errorMessage)}
                onTypeError={(errorMessage) => toast.error(errorMessage)}
                children={
                  <div>
                    <div className="flex items-center justify-center w-full">
                      <div className="flex flex-col items-center justify-center w-full py-[45px] px-3 md:px-5 border-2 border-dark_bg_v4 border-dashed rounded-lg cursor-pointer bg-light_bg_v5 dark:bg-dark-secondary hover:bg-gray-100 dark:border-color_dark dark:hover:border-gray-500 dark:hover:bg-gray-600">
                        <div className="flex flex-col items-center justify-center">
                          <div className="mb-[11px] h-[36px] w-[36]">
                            {darkMode ? (
                              <ImagePlacholderDark />
                            ) : (
                              <ImagePlacholder />
                            )}
                          </div>
                          <p className="text-small3 mb-[5px] lg:whitespace-nowrap text-center text-font_light_color dark:text-color_v1_dark">
                            {tComponent("image.drop_your_img")}, &nbsp;
                            <span className="text-small3_b text-main_color whitespace-nowrap">
                              {tComponent(`image.browse_image`)}
                            </span>
                          </p>
                          <p className="text-[10px] text-font_light_color dark:text-color_v2_dark tracking-[-0.3px] leading-[13px]">
                            2 MB {tComponent("image.maximum")}(.png,
                            .gif, .ico)
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              />
            )}
            {filePreview && (
              <div>
                <div className="flex items-center">
                  <div className="bg-light_bg_v4 dark:bg-dark-secondary rounded-lg cursor-pointer">
                    <img
                      className="h-[60px] w-[60px] sm:h-[68px] sm:w-[68px] p-1 object-cover rounded-lg"
                      src={filePreview}
                      alt="..."
                    />
                  </div>
                  <div>
                    <FileUploader
                      handleChange={handleChange}
                      name="file"
                      types={fileTypes}
                      maxSize={2}
                      onSizeError={(errorMessage) => toast.error(errorMessage)}
                      onTypeError={(errorMessage) => toast.error(errorMessage)}
                      children={
                        <div className="ps-[15px] text-small2_b text-main_color cursor-pointer">
                          {tComponent("image.choose_another")}
                        </div>
                      }
                    />
                  </div>
                </div>
              </div>
            )}
            <div className="mt-[10px] sm:mt-[15px]">
              <div>
                <div className="relative">
                  <div className="absolute inset-y-0 h-full sm:ps-[10px] ps-[16px] flex justify-center items-center">
                    {darkMode ? <GalleryEditDark /> : <GalleryEdit />}
                  </div>
                  <input
                    type="text"
                    id="description"
                    {...register("description")}
                    className={`rounded-md border bg-light_bg_v5 p-[13px] sm:p-[11px] py-[5px] sm:py-[3px] ps-[42px] sm:ps-[36px] px-[14px] sm:px-[16.5px] text-heading_color text-small2 sm:text-small1 focus:outline-none focus:ring-0 focus:placeholder:text-heading_color block w-full dark:bg-dark-secondary dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark ${
                      errors.description
                        ? "border-state_color_error dark:bg-dark-secondary"
                        : "border-light_bg_v2 focus:border-font_light_color dark:border-color_dark focus:dark:border-font_color"
                    }`}
                    placeholder={`${tComponent("image.image")} ${tComponent(
                      "image.description"
                    )}`}
                  />
                </div>

                {errors.description && (
                  <small className="text-state_color_error text-small3">
                    {errors?.description?.message}
                  </small>
                )}
              </div>
            </div>
            <div className="mt-[5px] sm:mt-[10px] relative">
              <div className="absolute inset-y-0 h-full sm:ps-[10px] ps-[16px] flex justify-center items-center">
                {darkMode ? <LinkIconDark /> : <LinkIcon />}
              </div>
              <input
                type="text"
                id="url"
                {...register("url")}
                className={`rounded-md border  bg-light_bg_v5 p-[13px] sm:p-[11px] py-[5px] sm:py-[3px] ps-[42px] sm:ps-[36px] px-[14px] sm:px-[16.5px] text-heading_color text-small2 sm:text-small1 focus:outline-none focus:ring-0 focus:placeholder:text-heading_color block w-full dark:bg-dark-secondary dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark ${
                  errors.url
                    ? "border-state_color_error dark:bg-dark-secondary"
                    : "border-light_bg_v2 focus:border-font_light_color dark:border-color_dark focus:dark:border-font_color"
                }`}
                placeholder={`${tComponent("image.description")} URL`}
              />
            </div>
            {errors.url && (
              <small className="text-state_color_error text-small3">
                {errors?.url?.message}
              </small>
            )}
            <div className="mt-[5px] sm:mt-[10px] relative">
              <div className="absolute inset-y-0 h-full sm:ps-[10px] ps-[16px] flex justify-center items-center">
                <TextIcon
                  className={`${
                    errors?.altDescription
                      ? "stroke-state_color_error"
                      : darkMode
                      ? "stroke-color_v1_dark"
                      : " stroke-heading_color"
                  }`}
                />
              </div>
              <input
                type="text"
                id="altDescription"
                {...register("altDescription")}
                className={`rounded-md border  bg-light_bg_v5 p-[13px] sm:p-[11px] py-[5px] sm:py-[3px] ps-[42px] sm:ps-[36px] px-[14px] sm:px-[16.5px] text-heading_color text-small2 sm:text-small1 focus:outline-none focus:ring-0 block w-full dark:bg-dark-secondary dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark ${
                  errors.altDescription
                    ? "border-state_color_error placeholder:text-state_color_error dark:bg-dark-secondary"
                    : "border-light_bg_v2 focus:border-font_light_color focus:placeholder:text-heading_color dark:border-color_dark focus:dark:border-font_color"
                }`}
                placeholder={`${tComponent("image.enter_alt_text")}`}
              />
            </div>
            {errors.altDescription && (
              <small className="text-state_color_error text-small3">
                {errors?.altDescription?.message}
              </small>
            )}
            <div className="flex mt-[26px] items-center justify-end">
              <button
                type="button"
                onClick={() => deleteHandler()}
                className="flex justify-center items-center"
              >
                {darkMode ? <TrashIconDark /> : <TrashIcon />}
                <p className="ps-1.5 pt-1 text-small3_b gray-700 text-heading_color dark:text-color_v1_dark">
                  {tComponent("image.delete_cap")}
                </p>
              </button>

              <ExtraSmallFilledButton
                name={`${tComponent("image.save_cap")}`}
                buttonType={"submit"}
                isLoading={isLoading}
                classes={"ms-3"}
              />
            </div>
          </form>
        </div>
      </div>
    </>
    </I18nextProvider>
  );
};

export default ImageForm;
